import httpClient from '../httpClient';
const get = async (id) => {
  return await httpClient.get(`/documents_repository?filename=${id}`);
};

export { get };
